import { styled } from "styled-components";
import theme from "styled-theming";

import { VideoWrapper as Video } from "components/Video/Video.styled";
import { Container as GridContainer } from "style/components/Page";
import { columnGap } from "style/grid";
import { MQ } from "style/mediaQueries";

const textColor = theme("theme", {
    lightgray: "--text-on-neutral-primary",
    cyan: "--text-on-cyan-primary",
    blue: "--text-on-blue-primary",
});

export const Container = styled(GridContainer)`
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    padding-bottom: 4.375rem;
    padding-top: 2.1875rem;
    position: relative;

    ${MQ.FROM_M} {
        padding-bottom: 6.125rem;
        padding-top: 3.5rem;
    }

    ${MQ.FROM_XL} {
        padding-bottom: 8.75rem;
        padding-top: 4.375rem;
    }
`;

export const Videos = styled.div.attrs<{
    $count: number;
}>(() => ({}))`
    ${columnGap};
    color: var(${textColor});
    display: grid;
    grid-template-columns: repeat(1, [col-start] 1fr);
    row-gap: 1.75rem;

    ${MQ.FROM_M} {
        grid-template-columns: repeat(3, [col-start] 1fr);
        row-gap: 2.1875rem;

        ${Video} {
            grid-column: 1 / span 2;

            &:nth-child(even) {
                grid-column: 2 / span 2;
            }
        }
    }

    ${MQ.FROM_L} {
        row-gap: 2.1875rem;
        grid-template-columns: repeat(2, [col-start] 1fr);

        ${Video} {
            grid-column: auto;

            &:nth-child(even) {
                grid-column: auto;
            }
        }
    }

    ${MQ.FROM_XL} {
        row-gap: 3.5rem;
    }
`;
